import React, { Suspense, useEffect } from 'react'
import './assets/style/tailwind.css'
import './assets/style/App.scss'
import { useTranslation } from 'react-i18next'
import { Routes, Route, Navigate } from 'react-router-dom'
import SideMenu from 'components/SideMenu/SideMenu'
import NavBar from 'components/NavBar/NavBar'
import Loading from 'components/Loading/Loading'
import { useSelector } from 'react-redux'
import { RootState } from 'redux/store/reducers'
import HomeDash from 'pages/admin/dashboard/HomeDash'
import Transportation from 'pages/admin/Transportation/Transportaion'
import AddTransportationContent from 'pages/admin/Transportation/addTransportaion/AddTransportationContent'
import Packages from 'pages/admin/packages/Packages'
import PackagesForm from 'pages/admin/packages/packagesForm/PackagesForm'
import i18n from './i18n'

// admin

const Login = React.lazy(() => import('pages/Login/Login'))

const Users = React.lazy(() => import('pages/admin/Users/Users'))
const FormUsers = React.lazy(() => import('pages/shared/FormUsers/FormUsers'))
const HotelsContent = React.lazy(() => import('pages/admin/Hotels/HotelsContent/HotelsContent'))
const AddHotelContent = React.lazy(() => import('pages/admin/Hotels/AddHotels/AddHotelContent'))

const Flight = React.lazy(() => import('pages/admin/Flight/Flight'))
const FormFlight = React.lazy(() => import('pages/admin/Flight/FormFlight/FromNavbar'))
const AddFlightReservation = React.lazy(
  () => import('pages/admin/Flight/FlightReservation/AddFlightReservation')
)
const AddFlightReservationDetails = React.lazy(
  () =>
    import(
      'pages/admin/Flight/FlightReservation/FlightGDS/reservationDetails/AddFlightReservationDetails'
    )
)
const AddReservationDetailsContent = React.lazy(
  () =>
    import(
      'pages/admin/Flight/FlightReservation/FlightGDS/reservationDetails/addReservationDetails/AddReservationDetaialsContent'
    )
)
const AddHotelReservation = React.lazy(
  () => import('pages/admin/Hotels/addReservation/AddHotelReservation')
)
const HotelGDSContent = React.lazy(
  () => import('pages/admin/Hotels/addReservation/sections/hotelGDS/HotelGDSContent')
)
const AddHotelReservationContent = React.lazy(
  () => import('pages/admin/Hotels/addReservation/sections/hotelGDS/AddHotelReservationContent')
)

const Catering = React.lazy(() => import('pages/admin/Catering/Catering'))
const FormCatering = React.lazy(() => import('pages/admin/Catering/FormCatering/FromNavbar'))

const Groups = React.lazy(() => import('pages/admin/Groups/Groups'))
const FromGroups = React.lazy(() => import('pages/admin/Groups/FormGroups/FromGroups'))

const Reservation = React.lazy(() => import('pages/admin/Reservation/Reservation'))

const Passports = React.lazy(() => import('pages/admin/Passports/Clients'))
const FormPassports = React.lazy(() => import('pages/admin/Passports/FormClients/FormClients'))

const FormReservation = React.lazy(
  () => import('pages/admin/Transportation/FormGroups/FormReservation')
)

const FormReservationPackage = React.lazy(
  () => import('pages/admin/packages/FormGroups/FormReservation')
)

const Settings = React.lazy(() => import('pages/admin/Settings/Settings'))
const MarketplaceSettings = React.lazy(() => import('pages/admin/marketPlace/MarketplaceSettings'))

const HotelsUsers = React.lazy(() => import('pages/admin/Hotels/HotelsUsers/HotelsUsers'))

function App(): JSX.Element {
  const { t } = useTranslation('', { i18n })
  const loadingCounter = useSelector((state: RootState) => state.Global.loadingCounter)
  const userInfo = useSelector((state: RootState) => state.UserInfo.user)
  const state = useSelector((state: RootState) => state)
  const userStr = localStorage.getItem('user')
  const user = userStr ? JSON.parse(userStr) : null
  const userData = localStorage.getItem('user')
  const userDataObj = userData ? JSON.parse(userData) : {}
  const permitions = userDataObj.Permissions || []
  const dashboardPer = permitions?.find((ele: any) => ele.Module === 'Dashboard')
  const HotelPer = permitions?.find((ele: any) => ele.Module === 'Hotel')
  const FlightPer = permitions?.find((ele: any) => ele.Module === 'Flight')
  const TrasportaitonPer = permitions?.find((ele: any) => ele.Module === 'Trasportaiton')
  const CateringPer = permitions?.find((ele: any) => ele.Module === 'Catering')
  const PackagePer = permitions?.find((ele: any) => ele.Module === 'Package')
  const ClientPer = permitions?.find((ele: any) => ele.Module === 'Client')
  const GroupPer = permitions?.find((ele: any) => ele.Module === 'Group')
  const UserPer = permitions?.find((ele: any) => ele.Module === 'User')
  const ConfigurationPer = permitions?.find((ele: any) => ele.Module === 'Configuration')
  return (
    <div
      className={`App   min-h-screen bg-neutral-100 ${i18n.language === 'en' ? 'ltr' : 'rtl'}`}
      dir={`${i18n.language === 'en' ? 'ltr' : 'rtl'}`}>
      {!user?.Token ? (
        <Suspense fallback={<Loading />}>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </Suspense>
      ) : (
        // <Suspense fallback={<Loading />}>
        //   <Routes>
        //     <Route path="pages/Login/Login" element={<Login />} />
        //   </Routes>
        // </Suspense>
        <div className="flex">
          <div className="w-2/12 print:hidden">
            <SideMenu />
          </div>
          <div className="w-10/12 px-4 print:w-full">
            <NavBar />
            {(loadingCounter > 0 || JSON.stringify(state).includes('pending')) && <Loading />}
            <Suspense fallback={<Loading />}>
              <Routes>
                <>
                  {dashboardPer?.IsActive && (
                    <Route path="/" element={<Navigate to="/admin/dashboard" replace />} />
                  )}

                  {HotelPer?.IsActive && (
                    <>
                      <Route path="/admin/hotels" element={<HotelsContent />} />
                      {HotelPer.Add && (
                        <Route path="/admin/hotels/addHotel" element={<AddHotelContent />} />
                      )}
                      {HotelPer.View && (
                        <Route
                          path="/admin/hotels/view/:id"
                          element={<AddHotelContent mode="view" />}
                        />
                      )}
                      {HotelPer.Edit && (
                        <Route
                          path="/admin/hotels/edit/:id"
                          element={<AddHotelContent mode="edit" />}
                        />
                      )}
                      {HotelPer.Reservation && (
                        <>
                          <Route
                            path="/admin/hotels/AddReservation"
                            element={<AddHotelReservation />}
                          />
                          <Route
                            path="/admin/hotels/AddReservation/hotels-gds/:id"
                            element={<AddHotelReservationContent />}
                          />
                          <Route
                            path="/admin/hotels/AddReservation/hotels-gds"
                            element={<HotelGDSContent />}
                          />
                        </>
                      )}
                    </>
                  )}
                  {/* <Route path="/admin/hotelsUsers/edit/:id" element={<FormUsers mode="edit" />} />
                  <Route path="/admin/hotelsUsers/view/:id" element={<FormUsers mode="view" />} /> */}
                  {dashboardPer?.IsActive && (
                    <Route path="/admin/Dashboard" element={<HomeDash />} />
                  )}

                  {UserPer.IsActive && (
                    <>
                      <Route path="/admin/users" element={<Users />} />
                      {UserPer.Add && <Route path="/admin/users/create" element={<FormUsers />} />}
                      {UserPer.Edit && (
                        <Route path="/admin/users/edit/:id" element={<FormUsers mode="edit" />} />
                      )}
                      {UserPer.View && (
                        <Route path="/admin/users/view/:id" element={<FormUsers mode="view" />} />
                      )}
                    </>
                  )}

                  {FlightPer.IsActive && (
                    <>
                      <Route path="/admin/flight" element={<Flight />} />
                      {FlightPer.Add && (
                        <Route path="/admin/flight/create" element={<FormFlight />} />
                      )}
                      {FlightPer.Edit && (
                        <Route path="/admin/flight/edit/:id" element={<FormFlight mode="edit" />} />
                      )}
                      {FlightPer.View && (
                        <Route path="/admin/flight/view/:id" element={<FormFlight mode="view" />} />
                      )}
                      {FlightPer.Reservation && (
                        <>
                          <Route
                            path="/admin/flight/AddReservation"
                            element={<AddFlightReservation />}
                          />
                          <Route
                            path="/admin/flight/flight-reservation/flight-gds"
                            element={<AddFlightReservationDetails />}
                          />
                          <Route
                            path="/admin/flight/flight-reservation/flight-gds/:id"
                            element={<AddReservationDetailsContent />}
                          />
                        </>
                      )}
                    </>
                  )}
                  {CateringPer.IsActive && (
                    <>
                      <Route path="/admin/catering" element={<Catering />} />
                      {CateringPer.Add && (
                        <Route path="/admin/catering/create" element={<FormCatering />} />
                      )}
                      {CateringPer.Edit && (
                        <Route
                          path="/admin/catering/edit/:id"
                          element={<FormCatering mode="edit" />}
                        />
                      )}
                      {CateringPer.View && (
                        <Route
                          path="/admin/catering/view/:id"
                          element={<FormCatering mode="view" />}
                        />
                      )}
                    </>
                  )}
                  {GroupPer.IsActive && (
                    <>
                      <Route path="/admin/groups" element={<Groups />} />
                      {GroupPer.Add && (
                        <Route path="/admin/groups/create" element={<FromGroups />} />
                      )}
                      {GroupPer.Edit && (
                        <Route path="/admin/groups/edit/:id" element={<FromGroups mode="edit" />} />
                      )}
                      {GroupPer.View && (
                        <Route path="/admin/groups/view/:id" element={<FromGroups mode="view" />} />
                      )}
                    </>
                  )}

                  {/* <Route path="/admin/reservation" element={<Reservation />} /> */}
                  {TrasportaitonPer.IsActive && (
                    <>
                      <Route path="/admin/Transportation" element={<Transportation />} />
                      {TrasportaitonPer.Add && (
                        <Route
                          path="/admin/transportation/create"
                          element={<AddTransportationContent />}
                        />
                      )}
                      {TrasportaitonPer.Reservation && (
                        <Route
                          path="/admin/transportation/reservation"
                          element={<FormReservation />}
                        />
                      )}
                      {TrasportaitonPer.View && (
                        <Route
                          path="/admin/transportation/view/:id"
                          element={<AddTransportationContent mode="view" />}
                        />
                      )}
                      {TrasportaitonPer.Edit && (
                        <Route
                          path="/admin/transportation/edit/:id"
                          element={<AddTransportationContent mode="edit" />}
                        />
                      )}
                    </>
                  )}
                  {PackagePer.IsActive && (
                    <>
                      <Route path="/admin/packages" element={<Packages />} />
                      {PackagePer.Add && (
                        <Route path="/admin/packages/create" element={<PackagesForm />} />
                      )}
                      {PackagePer.Edit && (
                        <Route
                          path="/admin/packages/edit/:id"
                          element={<PackagesForm mode="edit" />}
                        />
                      )}
                      {PackagePer.View && (
                        <Route
                          path="/admin/packages/view/:id"
                          element={<PackagesForm mode="view" />}
                        />
                      )}
                      {PackagePer.Reservation && (
                        <Route
                          path="/admin/packages/reservation"
                          element={<FormReservationPackage />}
                        />
                      )}
                    </>
                  )}
                  {ClientPer.IsActive && (
                    <>
                      <Route path="/admin/clients" element={<Passports />} />
                      {ClientPer.Add && (
                        <Route path="/admin/clients/create" element={<FormPassports />} />
                      )}
                      {ClientPer.Edit && (
                        <Route
                          path="/admin/clients/edit/:id"
                          element={<FormPassports mode="edit" />}
                        />
                      )}
                      {ClientPer.View && (
                        <Route
                          path="/admin/clients/view/:id"
                          element={<FormPassports mode="view" />}
                        />
                      )}
                    </>
                  )}
                  {/* <Route path="/admin/passports" element={<Passports />} />
                  <Route path="/admin/passports/create" element={<FormPassports />} />
                  <Route path="/admin/passports/edit/:id" element={<FormPassports mode="edit" />} />
                  <Route path="/admin/passports/view/:id" element={<FormPassports mode="view" />} /> */}
                  {ConfigurationPer.IsActive && (
                    <Route path="/admin/settings/*" element={<Settings />} />
                  )}
                  {ConfigurationPer.IsActive && (
                    <Route path="/admin/MarketplaceSettings" element={<MarketplaceSettings />} />
                  )}
                  {/* <Route path="*" element={<Navigate to="/admin/dashboard" replace />} /> */}
                </>
              </Routes>
            </Suspense>
          </div>
        </div>
      )}
    </div>
  )
}

export default App
